import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    if (event.key !== "Enter" || !event.ctrlKey || event.isComposing || event.keyCode === 229) return

    event.preventDefault()
    this.element.requestSubmit()
  }
}
